// extracted by mini-css-extract-plugin
export default {"mainContainer":"Certificates_mainContainer__KGcsy","certificateHeader":"Certificates_certificateHeader__CtU4Z","certificateContainer":"Certificates_certificateContainer__bFXCv"};